import { Link } from "react-router-dom";

function CategoryBar() {
  return (
    <>
      <nav className="category-bar">
        <div className="fk-cat-bar">
          <Link to="/" className="fk-cat-item">
            <img
              src="https://static-assets-web.flixcart.com/apex-static/images/svgs/L1Nav/all.svg"
              alt="For You"
            />
            <p>For You</p>
          </Link>

          <Link to="/category/1" className="fk-cat-item">
            <img
              src="https://static-assets-web.flixcart.com/apex-static/images/svgs/L1Nav/fashion.svg"
              alt="Fashion"
            />
            <p>Fashion</p>
          </Link>

          <Link to="/category/2" className="fk-cat-item">
            <img
              src="https://static-assets-web.flixcart.com/apex-static/images/svgs/L1Nav/mobiles.svg"
              alt="Mobiles"
            />
            <p>Mobiles</p>
          </Link>


          <Link to="/category/3" className="fk-cat-item">
            <img
              src="https://static-assets-web.flixcart.com/apex-static/images/svgs/L1Nav/beauty.svg"
              alt="Beauty"
            />
            <p>Beauty</p>
          </Link>

          <Link to="/category/4" className="fk-cat-item">
            <img
              src="https://static-assets-web.flixcart.com/apex-static/images/svgs/L1Nav/electronics.svg"
              alt="Electronics"
            />
            <p>Electronics</p>
          </Link>

          <Link to="/category/5" className="fk-cat-item">
            <img
              src="https://static-assets-web.flixcart.com/apex-static/images/svgs/L1Nav/home-final.svg"
              alt="Home"
            />
            <p>Home</p>
          </Link>

          <Link to="/category/6" className="fk-cat-item">
            <img
              src="https://static-assets-web.flixcart.com/apex-static/images/svgs/L1Nav/tv.svg"
              alt="Appliances"
            />
            <p>Appliances</p>
          </Link>

          <Link to="/category/7" className="fk-cat-item">
            <img
              src="https://static-assets-web.flixcart.com/apex-static/images/svgs/L1Nav/toy.svg"
              alt="Toys"
            />
            <p>Toys</p>
          </Link>

          <Link to="/category/8" className="fk-cat-item">
            <img
              src="https://static-assets-web.flixcart.com/apex-static/images/svgs/L1Nav/food.svg"
              alt="Food"
            />
            <p>Food & Health</p>
          </Link>

          <Link to="/category/9" className="fk-cat-item">
            <img
              src="https://static-assets-web.flixcart.com/apex-static/images/svgs/L1Nav/auto-acc.svg"
              alt="Auto"
            />
            <p>Auto</p>
          </Link>

          <Link to="/category/10" className="fk-cat-item">
            <img
              src="https://static-assets-web.flixcart.com/apex-static/images/svgs/L1Nav/auto-new.svg"
              alt="2 Wheelers"
            />
            <p>2 Wheelers</p>
          </Link>

          <Link to="/category/11" className="fk-cat-item">
            <img
              src="https://static-assets-web.flixcart.com/apex-static/images/svgs/L1Nav/sport.svg"
              alt="Sports"
            />
            <p>Sports</p>
          </Link>

          <Link to="/category/12" className="fk-cat-item">
            <img
              src="https://static-assets-web.flixcart.com/apex-static/images/svgs/L1Nav/books.svg"
              alt="Books"
            />
            <p>Books</p>
          </Link>

          <Link to="/category/13" className="fk-cat-item">
            <img
              src="https://static-assets-web.flixcart.com/apex-static/images/svgs/L1Nav/furniture.svg"
              alt="Furniture"
            />
            <p>Furniture</p>
          </Link>
        </div>
      </nav>
    </>
  );
}

export default CategoryBar;
